<template>
  <div class="flex items-center">
    <div
      class="rounded-lg px-1.5 py-1 flex items-center justify-center border text-xs transition-all"
      :class="[active ? '' : 'border-gray-400']" :style="{
        borderColor: active ? color : '',
      }">


      <Transition name="fade" mode="out-in">
        <EyeIcon v-if="active" class="w-3 h-3 mr-1 transition-all" :style="{
          color: color
        }" />
        <EyeSlashIcon v-else class="w-3 h-3 mr-1 text-gray-400 transition-all" />
      </Transition>

      <span class="transition-all" :class="[active ? '' : 'text-gray-400']">
        {{ label }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { colorsUtils } from '../utils/ColorsUtils';
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/outline'
withDefaults(defineProps<{
  label: string
  color?: string,
  active?: boolean
}>(), {
  color: colorsUtils.getColor(0),
  label: 'Badge',
  active: true
})

</script>